import type { CurrentUser } from './auth.api';

export type CurrentUserState = { status: 'loading' } | { status: 'authenticated'; user: CurrentUser } | { status: 'anonymous' };

export type CurrentUserAction = { type: 'loaded'; user: CurrentUser } | { type: 'unauthenticated' };

/** Pure so the app-start / 401 transitions are provable without rendering anything. */
export function reduceCurrentUser(_state: CurrentUserState, action: CurrentUserAction): CurrentUserState {
  switch (action.type) {
    case 'loaded':
      return { status: 'authenticated', user: action.user };
    case 'unauthenticated':
      return { status: 'anonymous' };
  }
}
